/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import clsx from 'clsx';
import styles from './ConfirmationOverlay.module.scss';
import { Button } from '../Button/Button';
export const ConfirmationOverlay = ({ content, title, handleOk, handleCancel, isOpen, okLabel, cancelLabel, type = 'alert', showIcon = true, showCloseIcon = true, cancelStyle = 'button', compact = false, darkBackdrop = false, blockButton = false, }) => {
    return (<>
      {isOpen && (<div className={clsx(styles.root, darkBackdrop && styles.darkBackdrop)}>
          <div className={clsx(styles.dialog, compact && styles.compactDialog, type === 'info' ? styles.grayDialog : type === 'success' ? styles.greenDialog : '')}>
            {showCloseIcon && (<button className={styles.dialogClose} onClick={handleCancel}>
                <img src='https://www.haven.com/assets/owners/shared/close_black.svg' alt='close'/>
              </button>)}
            {showIcon && type === 'alert' && (<div className={clsx(styles.alert, styles.dialogIcon)} data-testid='alert-icon'>
                !
              </div>)}
            {showIcon && type === 'info' && (<img className={styles.dialogIcon} src='https://www.haven.com/assets/owners/shared/info_darkBlue.svg' alt='info'/>)}
            {showIcon && type === 'success' && (<div className={clsx(styles.successIcon, styles.dialogIcon)}>
                <img src='https://www.haven.com/assets/owners/shared/check.svg' alt='check'/>
              </div>)}
            <h2>{title}</h2>
            {content}
            <div className={styles.btnGroup}>
              {handleOk && okLabel && (<Button variant='contained' onClick={handleOk} fullWidth={blockButton}>
                  {okLabel}
                </Button>)}
              {handleCancel && cancelLabel && cancelStyle === 'button' ? (<Button variant='outlined' onClick={handleCancel} fullWidth={blockButton} transparent={true}>
                  {cancelLabel}
                </Button>) : (<button className={styles.linkButton} onClick={handleCancel}>
                  {cancelLabel}
                </button>)}
            </div>
          </div>
        </div>)}
    </>);
};
